import React from 'react';
import { makeStyles } from '@material-ui/core';
import { GreshamLogo } from '../../assets';

const useStyles = makeStyles({
  svg: {
    width: '28px',
    height: '28px',
    objectFit: 'contain',
  },
});

export const LogoIcon = () => {
  const classes = useStyles();

  return (
    <img 
      className={classes.svg}
      src={GreshamLogo}
      alt="Gresham Tech Logo"
    />
  );
};
